import { createFileRoute } from '@tanstack/react-router';
import OfficePortal from '../../components/portals/office/OfficePortal';
import { OfficeKioskGate } from '../../components/site/OfficeKioskGate';

export const Route = createFileRoute('/portal/office')({
  component: OfficePortalRoute,
});

function OfficePortalRoute() {
  return (
    <OfficeKioskGate>
      <OfficePortal />
    </OfficeKioskGate>
  );
}
